import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

const LIST_MAX_HEIGHT = "260px";
const TRIGGER_MIN_WIDTH = "100px";
const TRIGGER_MAX_WIDTH = "200px";

export const useStyles = makeStyles({
  trigger: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: designTokens.spacing[2],
    minWidth: TRIGGER_MIN_WIDTH,
    maxWidth: TRIGGER_MAX_WIDTH,
    flexShrink: "1",
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[3]}`,
    fontFamily: "inherit",
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[900],
    backgroundColor: designTokens.neutral.white,
    border: `1px solid ${designTokens.neutral[300]}`,
    borderRadius: designTokens.borderRadius.sm,
    cursor: "pointer",
    transition: `border-color ${designTokens.transition.fast}`,
    ":hover": {
      border: `1px solid ${designTokens.neutral[500]}`,
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
    ":disabled": {
      cursor: "not-allowed",
      color: designTokens.neutral[400],
      backgroundColor: designTokens.neutral[100],
    },
  },
  triggerLabel: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  triggerIcon: {
    color: designTokens.neutral[500],
    flexShrink: "0",
  },
  surface: {
    padding: "0",
    minWidth: "240px",
  },
  searchRow: {
    padding: designTokens.spacing[3],
    borderBottom: `1px solid ${designTokens.neutral[200]}`,
  },
  search: {
    width: "100%",
    height: "36px",
    boxSizing: "border-box",
    backgroundColor: designTokens.neutral[50],
    border: `1px solid ${designTokens.neutral[300]}`,
    borderRadius: designTokens.borderRadius.md,
    fontSize: designTokens.fontSize.sm,
    "::after": {
      display: "none",
    },
    ":focus-within": {
      border: `1px solid ${designTokens.accent[500]}`,
      boxShadow: `0 0 0 3px ${designTokens.accent[100]}`,
      backgroundColor: designTokens.neutral.white,
    },
    "& input::placeholder": {
      color: designTokens.neutral[400],
    },
  },
  searchIcon: {
    color: designTokens.neutral[400],
  },
  list: {
    maxHeight: LIST_MAX_HEIGHT,
    overflowY: "auto",
    padding: `${designTokens.spacing[1]} 0`,
  },
  option: {
    display: "flex",
    alignItems: "center",
    minWidth: "100%",
    boxSizing: "border-box",
    height: designTokens.spacing[12],
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[3]}`,
    ":hover": {
      backgroundColor: designTokens.neutral[100],
    },
    "& .fui-Checkbox__label": {
      flexGrow: 1,
    },
    "& .fui-Checkbox__indicator": {
      alignSelf: "center",
    },
  },
  noMatches: {
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[3]}`,
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[500],
  },
});
